/**
 * PaymentBanner — Globalny sticky top banner dla statusów płatności
 * Value-based messaging
 */
import { AlertTriangle, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const BANNERS = {
  payment_failed: {
    bg: 'bg-[#FEE2E2]',
    border: 'border-[#FECACA]',
    text: 'text-[#991B1B]',
    icon: 'text-[#DC2626]',
    message: 'Płatność nie powiodła się — konto może zostać wstrzymane. Nie trać klientów.',
    cta: 'Uzupełnij płatność',
    ctaStyle: 'bg-[#DC2626] hover:bg-[#B91C1C] text-white',
  },
  grace_period: {
    bg: 'bg-[#F47A3B]/10',
    border: 'border-[#F47A3B]/30',
    text: 'text-[#9A3412]',
    icon: 'text-[#F47A3B]',
    message: 'Masz otwarte rozliczenie. Sprawdź, żeby konto nie zostało wstrzymane.',
    cta: 'Sprawdź rozliczenia',
    ctaStyle: 'bg-[#F47A3B] hover:bg-[#E06A2B] text-white',
  },
  suspended: {
    bg: 'bg-[#FEF3C7]',
    border: 'border-[#FDE68A]',
    text: 'text-[#92400E]',
    icon: 'text-[#D97706]',
    message: 'System wstrzymany — klienci nie mogą do Ciebie trafiać. Uzupełnij płatność.',
    cta: 'Aktywuj konto',
    ctaStyle: 'bg-[#D97706] hover:bg-[#B45309] text-white',
  },
};

export default function PaymentBanner({ status }) {
  const [dismissed, setDismissed] = useState(false);

  if (!status || !BANNERS[status] || dismissed) return null;

  const banner = BANNERS[status];

  return (
    <div className={`${banner.bg} ${banner.border} border-b px-4 py-2.5 flex items-center justify-between gap-3`} data-testid="payment-banner">
      <div className="flex items-center gap-2.5 min-w-0">
        <AlertTriangle className={`w-4 h-4 ${banner.icon} flex-shrink-0`} />
        <p className={`text-[13px] ${banner.text} font-medium truncate`}>{banner.message}</p>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <Link
          to="/panel/subskrypcja"
          className={`px-3.5 py-1.5 text-[12px] font-semibold rounded-lg transition-colors ${banner.ctaStyle}`}
          data-testid="payment-banner-cta"
        >
          {banner.cta}
        </Link>
        <button onClick={() => setDismissed(true)} className={`p-1 rounded ${banner.text} hover:opacity-70`}>
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
